export default "<div class=\"col-md-12 text-center {{className}}\">\n    <div class=\"styled-heading\">\n      <h3> {{msg}}</h3>\n    </div>\n  </div>";